import AdminRouting from '@/pages/Admin/Routing';

export default AdminRouting;
